import React, { useState, useEffect } from "react";
import { useIntl } from 'react-intl';

// Components
import { Form } from 'Components';
import Slider from 'Components/Slider';
import RadioGroup, { RadioCheck } from 'Components/RadioGroup';
// import TagPickerSelector from 'Modules/.common/components/TagPickerFilter/components/TagPickerSelector';

export const Geofence = (props) => {

    const { value, triggers, triggersRaw, onChange, formRef } = props
    const { messages } = useIntl()
    const [localLoading, setLocalLoading] = useState(true)

    // <---- Entity Selector Setup ---->
    const entities = [
        { id: "Geofence", label: "Geofence" },
        { id: "All", label: "All" },
    ];

    useEffect(() => {
        if (!triggersRaw) {
            let entities = triggers?.map(x => { return x.entity })
            let newValues = value
            if (!value.triggerDuration)
                newValues = {
                    "triggerDuration": {
                        "value": 0,
                        "duration": "Immediate"
                    },
                    "trigger": "Enter",
                    "recurring": {
                        "value": 0,
                        "frequency": "OnlyOnce"
                    }
                }
            onChange(newValues, entities)
            setLocalLoading(false)
        }
    }, [triggersRaw]);

    const durationLabel = {
        Minutes: messages['alertsNewAlert_minutes'],
        Hours: messages['alertsNewAlert_hours'],
        Days: messages['alertsNewAlert_days'],
    }

    if(localLoading) return


    return (
        <Form ref={formRef}
            onSubmit={() => {
                return triggersRaw?.length > 0;
            }}
        >
            <div className="form-item" style={{ padding: "10px 0" }}>
                <div style={{ width: "100%" }}>
                    {
                        (!triggersRaw || triggersRaw?.length == 0) &&
                        <div className="text-danger">
                            {messages["alertsNewAlert_itemValidation"]}
                        </div>
                    }
                    {/* <TagPickerSelector
                        entities={entities}
                        value={triggersRaw || []}
                        entity={entities.find(x => x.id == (triggersRaw?.find(x => x.id == "-1" && x?.name == 'All') && "All" || "Geofence"))}
                        onChangeEntity={(newSelectedEntity) => {

                            if (newSelectedEntity?.id === "All") {
                                onChange(value, [{ id: "-1", name: "All" }]);
                            } else {
                                onChange(value, []);
                            }
                        }}
                        onChange={(selectedItems, entity) => {
                            onChange(value,
                                selectedItems.map(selectedItem => {
                                    return { ...selectedItem, label: entity.id }
                                })
                            )
                        }}
                        height={240}
                        onlyTagsWithEntities={true}
                        showUntaggedAll={false}
                    /> */}
                </div>

                <div style={{ width: '100%', marginTop: 10, marginBottom: 30 }}>
                    <label className="input-normal-label">{messages['alertsNewAlert_triggersLabel']}</label>
                    {
                        value.trigger &&
                        <RadioGroup
                            id="rgCheck"
                            value={value.trigger}
                            onChange={(event) => onChange({ ...value, trigger: event }, triggersRaw)}
                            vertical
                        >
                            <RadioCheck className="blueCheck" id="enter" value="Enter" label={messages['alertsNewAlert_enter']} size='md' key="Enter" />
                            <RadioCheck className="blueCheck" id="exit" value="Exit" label={messages['alertsNewAlert_exit']} size='md' key="Exit" />
                            <RadioCheck className="blueCheck" id="both" value="All" label={messages['alertsNewAlert_both']} size='md' key="All" />
                        </RadioGroup>
                    }
                </div>

                <div style={{ width: '100%', marginTop: 10, marginBottom: 30 }}>
                    <label className="input-normal-label">{messages['alertsNewAlert_insideDuration']}</label>
                    {
                        value.triggerDuration?.duration &&
                        <RadioGroup
                            id="rgCheck"
                            value={value.triggerDuration?.duration || undefined}
                            vertical
                            onChange={(event) => {
                                let insideDuration = null;
                                event === 'Immediate' ? insideDuration = 0 : insideDuration = 1;
                                onChange({
                                    ...value, triggerDuration: { value: insideDuration, duration: event }
                                }, triggersRaw);
                            }}
                        >
                            <RadioCheck className="blueCheck" id="immediate" value="Immediate" label={messages['alertsNewAlert_immediate']} size='md' key="Immediate" />
                            <RadioCheck className="blueCheck" id="minutes" value="Minutes" label={messages['alertsNewAlert_minutes']} size='md' key="Minutes" />
                            <RadioCheck className="blueCheck" id="hours" value="Hours" label={messages['alertsNewAlert_hours']} size='md' key="Hours" />
                            <RadioCheck className="blueCheck" id="days" value="Days" label={messages['alertsNewAlert_days']} size='md' key="Days" />
                        </RadioGroup>
                    }
                </div>

                {
                    value.triggerDuration?.duration && value.triggerDuration?.duration != "Immediate" &&
                    <div style={{ width: '100%', marginTop: 10, marginBottom: 30 }}>
                        <label className="input-normal-label">
                            {durationLabel[value.recurring?.frequency]}
                            {value.triggerDuration?.duration == "Minutes" && messages['alertsNewAlert_minutes']}
                            {value.triggerDuration?.duration == "Hours" && messages['alertsNewAlert_hours']}
                            {value.triggerDuration?.duration == "Days" && messages['alertsNewAlert_days']}
                        </label>
                        <Slider
                            value={value.triggerDuration?.value}
                            onChange={(event) => onChange(
                                {
                                    ...value,
                                    triggerDuration: { ...value.triggerDuration, value: event },
                                }, triggersRaw
                            )}
                            min={1}
                            max={
                                value.triggerDuration?.duration == "Minutes" && 60 ||
                                value.triggerDuration?.duration == "Hours" && 24 ||
                                value.triggerDuration?.duration == "Days" && 30 || 0
                            }
                            sliderOneColor={false}
                            showValue
                            valueLabelDisplay={'off'}
                            disabled={!value.triggerDuration.duration}
                        />
                    </div>
                }

                <div style={{ width: '100%', marginTop: 10, marginBottom: 30 }}>
                    <label className="input-normal-label">{messages['alertsNewAlert_recurring']}</label>
                    {
                        value.recurring?.frequency &&
                        <RadioGroup
                            id="rgCheck"
                            value={value.recurring?.frequency}
                            vertical
                            onChange={(event) => {
                                let frequency = null;
                                event === 'OnlyOnce' ? frequency = 0 : frequency = 1;
                                onChange({
                                    ...value, recurring: { value: frequency, frequency: event }
                                }, triggersRaw);
                            }}
                        >
                            <RadioCheck className="blueCheck" id="onlyOnce" value="OnlyOnce" label={messages['alertsNewAlert_onlyOnce']} size='md' key="OnlyOnce" />
                            <RadioCheck className="blueCheck" id="minutes" value="Minutes" label={messages['alertsNewAlert_minutes']} size='md' key="Minutes" />
                            <RadioCheck className="blueCheck" id="hours" value="Hours" label={messages['alertsNewAlert_hours']} size='md' key="Hours" />
                            <RadioCheck className="blueCheck" id="days" value="Days" label={messages['alertsNewAlert_days']} size='md' key="Days" />
                        </RadioGroup>
                    }
                </div>
                {
                    value.recurring?.frequency && value.recurring?.frequency != "OnlyOnce" &&
                    <div style={{ width: '100%', marginTop: 10, marginBottom: 30 }}>
                        <label className="input-normal-label">
                            {durationLabel[value.recurring?.frequency]}
                        </label>
                        <Slider
                            value={value.recurring?.value}
                            onChange={(event) => onChange({ ...value, recurring: { ...value.recurring, value: event } }, triggersRaw)}
                            min={1}
                            max={
                                value.recurring?.frequency == "Minutes" && 60 ||
                                value.recurring?.frequency == "Hours" && 24 ||
                                value.recurring?.frequency == "Days" && 30 || 0
                            }
                            sliderOneColor={false}
                            showValue
                            valueLabelDisplay={'off'}
                            disabled={!value.recurring?.frequency}
                        />
                    </div>
                }
            </div>
        </Form>
    );
}

